export default __webpack_public_path__ + "static/media/by.7e0050e5.svg";